import React, { useEffect, useState } from "react";
import { Input, Button, Switch } from "antd";
import { useNavigate, useParams, Navigate, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import firebase from "../../config/firebase";
import NewMiniDrawer from "../../components/navMenu/menu-nav";
import { Dialog, DialogTitle, DialogContent, DialogActions } from "@mui/material";
import ModernAlertDialog from "../frete/components/ModernAlertDialog";
import "./paymentCondition.css";

import "firebase/auth";
import "firebase/firestore";

const DEFAULT_OPTIONS = [
  "Boleto - A vista",
  "Boleto - 7 dias",
  "Boleto - 7/14 dias",
  "Boleto - 7/14/21 dias",
  "Boleto - 7/14/21/28 dias",
  "Boleto - 10 dias",
  "Boleto - 10/20 dias",
  "Boleto - 10/20/30 dias",
  "Boleto - 10/20/30/40 dias",
  "Boleto - 15 dias",
  "Boleto - 15/30 dias",
  "Boleto - 15/30/45 dias",
  "Boleto - 15/30/45/60 dias",
  "Boleto - 20 dias",
  "Boleto - 20/40 dias",
  "Boleto - 21 dias",
  "Boleto - 21/42 dias",
  "Boleto - 28 Dias",
  "Boleto - 30 dias",
  "Boleto - 30/60 dias",
  "Boleto - 30/45/60 dias",
  "Boleto - 40 Dias",
  "Boleto - 45 Dias",
  "Boleto - 60 Dias",
];

function PaymentConditionForm() {
  const db = firebase.firestore();
  const navigate = useNavigate();
  const location = useLocation();
  const { id } = useParams();

  const userLogado = useSelector((state) => state.usuarioLogado);
  const user = useSelector((state) => state.user);

  const canCreate = user?.permissoes?.paymentCondition?.isCreate === true;
  const canEdit = user?.permissoes?.paymentCondition?.isEdit === true;
  const canView = user?.permissoes?.paymentCondition?.isView === true;
  const isEditRoute = Boolean(id);
  const isNewRoute = !id;

  const [view, setOnlyView] = useState(
    () =>
      location.state?.viewOnly === true ||
      (Boolean(id) && !canEdit && canView),
  );
  const [description, setDescription] = useState("");
  const [observation, setObservation] = useState("");
  const [active, setActive] = useState(true);
  const [loading, setLoading] = useState(false);
  const [conditions, setConditions] = useState([]);
  const [openOptionsModal, setOpenOptionsModal] = useState(false);
  const [openInfoDialog, setOpenInfoDialog] = useState(false);
  const [infoDialogTitle, setInfoDialogTitle] = useState("");
  const [infoDialogMsg, setInfoDialogMsg] = useState("");
  const [openCancelDialog, setOpenCancelDialog] = useState(false);

  useEffect(() => {
    const unsubscribe = db.collection("paymentCondition").onSnapshot((snapshot) => {
      const data = snapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
      setConditions(data);
    });

    return () => unsubscribe();
  }, []);

  useEffect(() => {
    if (!id) return;

    let cancelled = false;

    const loadCondition = async () => {
      try {
        const doc = await db.collection("paymentCondition").doc(id).get();
        if (!cancelled && doc.exists) {
          const data = doc.data();
          setDescription(data.description || "");
          setObservation(data.observation || "");
          setActive(data.active ?? true);
        }
      } catch (error) {
        console.error("Erro ao carregar condicao de pagamento:", error);
      }
    };

    loadCondition();

    return () => {
      cancelled = true;
    };
  }, [db, id]);

  const getInvalidFields = () => {
    const errors = [];

    if (!description || !description.trim()) {
      errors.push("Descricao");
    }

    if ((observation || "").length > 200) {
      errors.push("Observacoes (maximo de 200 caracteres)");
    }

    const descriptionTrimmed = description.trim().toLowerCase();
    const duplicatedDescription = conditions.some(
      (condition) =>
        condition.description?.toLowerCase() === descriptionTrimmed &&
        condition.id !== id
    );

    if (duplicatedDescription) {
      errors.push("Descricao (ja existe uma condicao com esta descricao)");
    }

    return errors;
  };

  const handleSave = async () => {
    if (view) return;

    const invalidFields = getInvalidFields();

    if (invalidFields.length > 0) {
      setInfoDialogTitle("Campo obrigatorio");
      setInfoDialogMsg(["Verifique os seguintes campos:", ...invalidFields]);
      setOpenInfoDialog(true);
      return;
    }

    setLoading(true);

    const payload = {
      description: description.trim(),
      observation: observation || "",
      active,
      uidShipper: user?.uidShipper || null,
    };

    try {
      if (id) {
        await db
          .collection("paymentCondition")
          .doc(id)
          .update({ ...payload, updated_at: new Date() });
      } else {
        await db.collection("paymentCondition").add({
          ...payload,
          created_at: new Date(),
        });
      }

      setInfoDialogTitle(
        id
          ? "Condicao de pagamento atualizada"
          : "Condicao de pagamento cadastrada"
      );
      setInfoDialogMsg(
        id
          ? "A condicao de pagamento foi atualizada com sucesso."
          : "A condicao de pagamento foi cadastrada com sucesso."
      );
      setOpenInfoDialog(true);
    } catch (error) {
      console.error("Erro ao salvar condicao de pagamento:", error);
      setInfoDialogTitle("Erro ao salvar");
      setInfoDialogMsg("Ocorreu um erro ao salvar a condicao de pagamento. Tente novamente.");
      setOpenInfoDialog(true);
    } finally {
      setLoading(false);
    }
  };

  if (userLogado <= 0) {
    return <Navigate to="/login" />;
  }

  if (isNewRoute && !canCreate) {
    return <Navigate to="/paymentCondition" replace />;
  }

  if (isEditRoute && !canEdit && !canView) {
    return <Navigate to="/paymentCondition" replace />;
  }

  const pageTitle = isEditRoute
    ? view
      ? "Visualizar Condicao de Pagamento"
      : "Editar Condicao de Pagamento"
    : "Cadastro de Condicoes de Pagamento";

  return (
    <NewMiniDrawer
      divOpen={
        <div className="freight-content">
          <div className="container">
            <h4>{pageTitle}</h4>

            <div className="row mt-4">
              <div className="col-md-6">
                Descricao <span style={{ color: "red" }}>*</span>
                <Input
                  value={description}
                  onChange={(e) => setDescription(e.target.value)}
                  placeholder="Informe a descricao"
                  disabled={view}
                />
              </div>

              {!view ? (
                <div className="col-md-3 d-flex align-items-end">
                  <Button className="btn-form-fortio" onClick={() => setOpenOptionsModal(true)}>
                    Modelos
                  </Button>
                </div>
              ) : (
                <div className="col-md-3" />
              )}

              <div className="col-md-3">
                <label>Ativo</label>
                <br />
                <Switch
                  checked={active}
                  onChange={setActive}
                  disabled={view}
                  style={{
                    backgroundColor: active ? "#012443" : "#d9d9d9",
                  }}
                />
              </div>
            </div>

            <div className="row mt-3">
              <div className="col-md-12">
                <label>Observacoes</label>
                <Input.TextArea
                  rows={3}
                  maxLength={200}
                  showCount={!view}
                  value={observation}
                  onChange={(e) => setObservation(e.target.value)}
                  disabled={view}
                />
              </div>
            </div>

            <div className="row mt-4">
              <div className="col-md-12 d-flex gap-2">
                <Button
                  className="btn-form-fortio btn-back-fortio"
                  onClick={() => navigate("/paymentCondition")}
                >
                  Voltar
                </Button>

                {!view ? (
                  <>
                    <Button className="btn-form-fortio" onClick={() => setOpenCancelDialog(true)}>
                      Cancelar
                    </Button>

                    <Button className="btn-form-fortio" loading={loading} onClick={handleSave}>
                      Salvar
                    </Button>
                  </>
                ) : null}
              </div>
            </div>
          </div>

          <ModernAlertDialog
            open={openInfoDialog}
            handleClose={() => {
              setOpenInfoDialog(false);
              if (
                infoDialogTitle === "Condicao de pagamento atualizada" ||
                infoDialogTitle === "Condicao de pagamento cadastrada"
              ) {
                navigate("/paymentCondition");
              }
            }}
            title={infoDialogTitle}
            msg={infoDialogMsg}
          />

          <ModernAlertDialog
            open={openCancelDialog}
            handleClose={() => setOpenCancelDialog(false)}
            title="Cancelar cadastro"
            msg="Deseja cancelar? As alteracoes nao salvas serao perdidas."
            showCancel
            confirmLabel="Confirmar"
            cancelLabel="Voltar"
            onConfirm={() => navigate("/paymentCondition")}
            onCancel={() => setOpenCancelDialog(false)}
          />

          <Dialog
            open={openOptionsModal}
            onClose={() => setOpenOptionsModal(false)}
            fullWidth
            maxWidth="sm"
          >
            <DialogTitle>Modelos de Condicoes de Pagamento</DialogTitle>
            <DialogContent dividers>
              <div style={{ display: "grid", gap: 8 }}>
                {DEFAULT_OPTIONS.map((option) => (
                  <Button
                    key={option}
                    onClick={() => {
                      setDescription(option);
                      setOpenOptionsModal(false);
                    }}
                  >
                    {option}
                  </Button>
                ))}
              </div>
            </DialogContent>
            <DialogActions>
              <Button onClick={() => setOpenOptionsModal(false)} danger>
                Fechar
              </Button>
            </DialogActions>
          </Dialog>
        </div>
      }
    />
  );
}

export default PaymentConditionForm;


